import { FC } from 'react';
import { Modal, Button, Image } from '@bfe/moly';
import cls from 'classnames';
// import { markNewUserGuideReadStatus } from '@/app/biz';
import { useMarket } from '@/store/market';
import { useI18n } from '@spot-fe/base-ui';
import { useStep, Item } from './step';
import styles from './index.module.scss';

interface IProps {
  open?: boolean;
}

export const GuideModal: FC<IProps> = ({ open }) => {
  const { t } = useI18n();

  const guides: Item[] = [
    {
      label: t('introPreMarketTrad'),
      content: (
        <div className={styles.page}>
          <Image
            className={styles.banner}
            alt=""
            src="https://fh-static.bycsi.com/guide-1-light-07bfdf2afe447bcf735557d45e7e742a.svg"
          />
          <div className={styles.passage}>{t('preMarketTradingInfo1')}</div>
        </div>
      ),
    },
    {
      label: t('deliveryOfTokens'),
      content: (
        <div className={styles.page}>
          <Image
            className={styles.banner}
            alt=""
            src="https://fh-static.bycsi.com/guide-2-light-eee035bfadb14645fd593b7b30da5a8d.svg"
          />
          <div className={styles.passage}>{t('deliveryInstructions')}</div>
        </div>
      ),
    },
    {
      label: t('riskWarning'),
      content: (
        <div className={styles.page}>
          <Image
            className={styles.banner}
            alt=""
            src="https://fh-static.bycsi.com/guide-3-light-9dac1dce0178afb31f6126323f2bd331.svg"
          />
          <div className={styles.passage}>{t('tradingNotice')}</div>
        </div>
      ),
    },
  ];

  const { items, current, nextStep, prevStep, goStep, hasNext, hasPrev } =
    useStep({
      items: guides,
    });

  const store = useMarket();

  const close = () => {
    store.setDisplayNewUserGuide(false);
  };

  const complete = () => {
    store.setNewUserGuideRead(true);
    store.setDisplayNewUserGuide(false);
  };

  return (
    <Modal
      title={t('preMarket')}
      size="large"
      className={styles.userGuide}
      open={store.displayNewUserGuide}
      onCancel={close}
      footer={null}
    >
      <div className={styles.body}>
        <div className={styles.left}>
          {items.map((item, idx) => {
            return (
              <div
                key={item.label}
                className={cls(styles.title, {
                  [styles.active]: item.isCurrent,
                })}
                onClick={() => {
                  goStep(idx);
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
        <div className={styles.content}>{current?.content}</div>
      </div>
      <div className={styles.footer}>
        {hasPrev ? (
          <div className={styles.prev} onClick={prevStep}>
            {t('previous')}
          </div>
        ) : null}
        {hasNext ? (
          <Button variant="primary" className={styles.next} onClick={nextStep}>
            {t('next')}
          </Button>
        ) : (
          <Button variant="primary" className={styles.next} onClick={complete}>
            {t('done')}
          </Button>
        )}
      </div>
    </Modal>
  );
};
